import {
  faDownLeftAndUpRightToCenter,
  faMinus,
  faPlus,
  faUpRightAndDownLeftFromCenter,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import ARPlayer from "../components/common/ARPlayer";
import TogglePlayerButton from "./TogglePlayerButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isMobile, isTablet } from "react-device-detect";
import PDFsketchfab from "../components/common/PDFsketchfab";
import VideoPlayerSketchfab from "../components/common/VideoPlayerSketchfab";

const SketchfabPlayerOnly = ({ assetId, arPlayerId, animationCollection, assetData }) => {
  const [animationStatus, setAnimationStatus] = useState(true);
  const [audioFile, setAudioFile] = useState(null);
  const [audioTitle, setAudioTitle] = useState("Play");
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [audioSample1, setAudioSample1] = useState();
  const [animationTitle, setAnimationTitle] = useState("Play Animation");
  const [annotationTitle, setAnnotationTitle] = useState("Play Animation");
  const [iconClicked, setIconClicked] = useState("");
  const [currentAnnotationLength, setCurrentAnnotationLength] = useState(0);
  const [toggleCutIdleState, setToggleCutIdleState] = useState("cutView");
  const [toggleExplodedCombineState, setToggleExplodedCombineState] =
    useState("exploded");
  const [isValid, setIsValid] = useState(true);
  const [faIcon, setFaIcon] = useState(faUpRightAndDownLeftFromCenter);
  const [iconTitle, setIconTitle] = useState({ fullscreen: "Fullscreen" });
  const [sketchfabApi, setSketchfabApi] = useState();
  const [animationList, setAnimationList] = useState();
  const [sliderValue, setSliderValue] = useState(0);
  const [pdfModal, setPdfModal] = useState(false);
  const toggleShowPdfModal = () => setPdfModal(!pdfModal);
  const [enableAnnotation, setEnableAnnotation] = useState(true);
  const [arplayer, setArplayer] = useState(null);
  const [videoPlayer, setVideoPlayer] = useState(null);
  const [pdfPlayer, setPDFplayer] = useState(null);

  // AR Player
  const toggleARModal = () => {
    setArplayer(`https://testing.paracosma.com/ar-object-viewer/${arPlayerId}`);
  };

  const toggleVideoPlayer = () => {
    setVideoPlayer(assetData.video);
  };

  const togglePDFPlayer = () => {
    setPDFplayer(assetData.pdf);
  };

  let isActive = false;

  const container = document.querySelector(".play-pause-container");

  // Hide Annotation Toggle
  const togglePlayPause = (data) => {
    data === "play" ? sketchfabApi.play() : sketchfabApi.pause();
    data === "play"
      ? audioSample1 && audioSample1.play()
      : audioSample1 && audioSample1.pause();

    // console.log(data, "data");
    if (data === "play") {
      document
        .getElementById("audio-controls")
        .classList.add("distinct-active");
    }

    if (data === "pause") {
      document
        .getElementById("audio-controls")
        .classList.remove("distinct-active");
    }

    // console.log(container)
    container.classList.toggle("active");
  };

  /**
   * Active Status for Buttons
   */
  const setActive = (event, className) => {
    // find the swatches collection you want to apply this function too
    var tempName = event.currentTarget.getAttribute("data-name"); // Use getAttribute to access data-* attribute
    var elements = document.querySelectorAll(`[data-name="${tempName}"]`);
    if (tempName === "controls-annotation") {
      event.currentTarget.classList.toggle(className);
    } else {
      // remove all the active status
      isActive = false;
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.remove(className);
      }

      // add the status on the one that is clicked!!
      event.currentTarget.classList.add(className);
    }
  };

  const clearActiveState = (
    tempName = "controls",
    className = "control-active"
  ) => {
    var elements = document.querySelectorAll(`[data-name="${tempName}"]`);
    // remove all the active status
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove(className);
    }
  };

  /**
   * Function to get the animation Id from using a string value
   */
  const getAnimationIdWithString = (name) => {
    if (typeof name === "number") {
      return animationList[name];
    }
    if (sketchfabApi) {
      if (animationList) {
        const data = animationList.filter((item) => {
          const stateName = item[1].toLowerCase();
          if (stateName.includes(name)) return item;
        });

        return data[0];
      }
    }
  };

  const setAnimation = (data) => {
    if (sketchfabApi) {
      sketchfabApi.setCurrentAnimationByUID(data.id);

      sketchfabApi.seekTo(0);
      window.duration = data.lengthAni;
      sketchfabApi.play();

      if (data === "-1" && assetData.position) {
        sketchfabApi.setCameraLookAt(assetData.position, assetData.target, 2.3);
      }
    }
  };

  /**
   * ZoomIn and ZoomOut Function Calls
   */

  const zoomIn = () => {
    if (sketchfabApi && assetData.zoomInPosition) {
      sketchfabApi.setCameraLookAt(
        assetData.zoomInPosition,
        assetData.zoomInTarget,
        2.3
      );
    }
  };

  const zoomOut = () => {
    if (sketchfabApi && assetData.zoomOutPosition) {
      sketchfabApi.setCameraLookAt(
        assetData.zoomOutPosition,
        assetData.zoomOutTarget,
        2.3
      );
    }
  };

  var currentAnnotation = 0;

  const handlePrevAnnotation = () => {
    if (currentAnnotation === 0) currentAnnotation = currentAnnotationLength;
    currentAnnotation--;
    sketchfabApi.gotoAnnotation(currentAnnotation, {
      preventCameraAnimation: false,
      preventCameraMove: false,
    });
  };

  const handleNextAnnotation = () => {
    if (currentAnnotation === currentAnnotationLength - 1)
      currentAnnotation = -1;
    currentAnnotation++;
    sketchfabApi.gotoAnnotation(currentAnnotation, {
      preventCameraAnimation: false,
      preventCameraMove: false,
    });
  };

  // Show Annotations
  const showAnnotations = () => {
    if (animationCollection?.exploded) {
      setAnimation(animationCollection.exploded);
    }
    setEnableAnnotation(false);
    setAnnotationTitle("Hide Annotation");

    for (let i = 0; i < currentAnnotationLength; i++) {
      sketchfabApi.showAnnotation(i);
    }
    sketchfabApi.showAnnotationTooltips();
  };

  // Hide Annotations
  const hideAnnotations = () => {
    setEnableAnnotation(true);
    setAnnotationTitle("Show Annotation");

    for (let i = 0; i < currentAnnotationLength; i++) {
      sketchfabApi.hideAnnotation(i);
    }
    sketchfabApi.hideAnnotationTooltips();
  };

  useEffect(() => {
    // Audio Controls
    if (assetData?.audio) setAudioSample1(document.getElementById("audio1"));
    /**
     * Get the Sketchfab Player API
     */
    const iframe = document.getElementById("api-frame-viewer");
    const version = "1.12.1";
    const client = new window.Sketchfab(version, iframe);
    var _pollTime;
    var timeSlider;
    var isSeeking;
    var current_anim;

    const uid = assetId;
    const success = function success(api) {
		setSketchfabApi(api);
		// console.log("Asset Detsils", api)
		// Reset all presets icons and properties
		setAudioFile(null)
		setAnimation(-1, 0)
		clearActiveState()
		setAnimationStatus(true)
		setEnableAnnotation(true)
		setAudioTitle('Play')
		setIsAudioPlaying(false)
		setAnimationTitle('Play Animation')
		setAnnotationTitle('Show Annotation')
		setToggleCutIdleState('cutView')
		setToggleExplodedCombineState('exploded')
		setIsValid(true);
		// initializeProperties()

    //   api.start();
		api.start(() => {
			api.addEventListener("viewerready", () => {
				if (assetData.position) {
					api.setCameraConstraints({
						fov: 45,
						nearFarRatio: 0.005,
						position: assetData.position,
						target: assetData.target,
						useCameraConstraints: true,
						usePanConstraints: false,
						usePitchConstraints: false,
						useYawConstraints: false,
						useZoomConstraints: true,
						zoomIn: assetData.zoomIn ? assetData.zoomIn : 0.05,
						zoomOut: assetData.zoomOut ? assetData.zoomOut : 0.5,
					});
					
					api.setCameraLookAt(assetData.position, assetData.target, 2.3);
				}
				api.setEnableCameraConstraints(true, () => {
				  api.setUserInteraction(true);
				});
		
				api.getAnimations((err, animations) => {
				  setAnimationList(animations);
				});
		
				api.getAnnotationList((err, annotations) => {
				  if (!err) {
					window.annotationLength = Object.keys(annotations).length;
					setCurrentAnnotationLength(annotations.length);
				  }
				});
		
				// Set Animation Mode
				api.setCycleMode("one", (err) => {
				  if (!err) {
					//window.console.log("Set animation cycle mode");
				  }
				});
		
				// Hide Annotations
				// Give value other than 15 say window.annoation.Length won't work, you need to give a actual number for this to work.
				for (let i = 0; i < 15; i++) {
				  api.hideAnnotation(i, (err, index) => {
					if (!err) {
					  //window.console.log("Hiding annotation", index + 1);
					}
				  });
				}
		
				_pollTime = function pollTime() {
				  api.getCurrentTime((err, time) => {
					if (!isSeeking) {
					  var percentage = (100 * time) / window.duration;
					  timeSlider.value = percentage;
					  const slider = document.getElementById("timeSlider");
					  slider.style.background = `linear-gradient(to right, #1466dd 0%, #1466dd  ${percentage}%, #d3d3d3 ${percentage}%, #d3d3d3 100%)`;
					}
					requestAnimationFrame(_pollTime);
				  });
				};
		
				api.getAnimations((err, animations) => {
				  	if (animations.length > 0) {
					    current_anim = 0;
					    api.setCurrentAnimationByUID(-1);
					    window.duration = animations[current_anim][2];
					    isSeeking = false;
					    timeSlider = document.getElementById("timeSlider");
					    _pollTime();
					    timeSlider.addEventListener("change", function () {
					      isSeeking = false;
					      api.play();
					      audioSample1 && audioSample1.play();
					    });
					    timeSlider.addEventListener("input", function () {
					      isSeeking = true;
					      var time = (window.duration * timeSlider.value) / 100;
					      api.pause();
					      api.seekTo(time, function () {
						api.play();
					      });
					      audioSample1 && (audioSample1.currentTime = time);
					    });
					}
				});
			});
		})
    };

    client.init(uid, {
      success: success,
      error: function onError() {
        setIsValid(false);
      },
      ui_stop: 0,
      autostart: 1,
      preload: 0,
      annotation: 0,
      ui_watermark: 0,
      ui_settings: 0,
      ui_inspector: 0,
      ui_infos: 0,
      ui_fullscreen: 0,
      ui_controls: 0,
      animation_autoplay: 0,
      ui_ar_help: 0,
      api_log: 1,
    });
  }, [assetId, audioSample1]);

	useEffect(() => {
		if (iconClicked) {
			switch (iconClicked) {
			case "cutView":
				setToggleExplodedCombineState("exploded");
				break;

			case "exploded":
				setToggleCutIdleState("cutView");
				break;

			default:
				break;
			}
		}
	}, [iconClicked]);

  const togglePlayAnimation = (event) => {
    resetAllPlayer();
    if (animationStatus) {
      setActive(event, "control-active");
      setAnimationTitle("Stop Animation");
      setAnimation(animationCollection.playAni);
      if (assetData.audio && audioSample1) {
        document.getElementById("voiceover").style.opacity = 1;
        audioSample1.currentTime = 0;
        audioSample1.play();
        document
          .getElementById("audio-controls")
          .classList.add("distinct-active");
        setIsAudioPlaying(true);
      }
      // console.log(audioSample1);
    } else {
      clearActiveState();
      setAnimationTitle("Play Animation");
      setAnimation("-1", 0);

      if (assetData.audio && audioSample1) {
        document.getElementById("voiceover").style.opacity = 0;
        audioSample1.pause();
        document
          .getElementById("audio-controls")
          .classList.remove("distinct-active");
        setIsAudioPlaying(false);
      }
    }

		setAnimationStatus(!animationStatus);
		hideAnnotations();
	};

  // Handle Annotation Controls
  const toggleAnnotation = (event) => {
    // clearActiveState()
    resetAllPlayer();
    if (enableAnnotation) {
      showAnnotations();
      event.currentTarget.classList.add("control-active");
      // setEnableAnnotation(false);
    } else {
      hideAnnotations();
      event.currentTarget.classList.remove("control-active");
      // setEnableAnnotation(true);
    }

    setToggleCutIdleState("cutView");
    setToggleExplodedCombineState("exploded");
  };

  /**
   * Handle Audio Player
   */
  const handleAudio = (data, state) => {
    setAudioFile(data);
    if (isAudioPlaying) {
      document
        .getElementById("audio-controls")
        .classList.remove("distinct-active");
      setAudioTitle("Play");
      audioSample1 && audioSample1.pause();
    } else {
      document
        .getElementById("audio-controls")
        .classList.add("distinct-active");
      setAudioTitle("Pause");
      audioSample1 && audioSample1.play();
    }

    setIsAudioPlaying(!isAudioPlaying);
  };
  /**
   * Reset All Buttons
   */
  const resetAllPlayer = () => {
    hideAnnotations();
    clearActiveState();
    setAnimation("-1", 0);
    setAnimationStatus(true);
    setToggleCutIdleState("cutView");
    setAnimationTitle("Play Animation");
    setToggleExplodedCombineState("exploded");
  };

  const handleFullScreen = () => {
    const fullScreenNav = document.getElementById("fullscreen-part");
    if (!document.fullscreenElement) {
      // document.documentElement.requestFullscreen();
      fullScreenNav.webkitRequestFullscreen();
      setFaIcon(faDownLeftAndUpRightToCenter);
      setIconTitle({ fullscreen: "Exit Fullscreen" });
    } else {
      document.exitFullscreen();
      setFaIcon(faUpRightAndDownLeftFromCenter);
      setIconTitle({ fullscreen: "Fullscreen" });
    }
  };

  return (
    <>
      {isValid && (
        <>
          <Row
            className="fullscreen-viewer mx-0 py-1 px-0"
            id="fullscreen-part"
          >
            <iframe
              id="api-frame-viewer"
              title="Paracosma"
              className="viewer-iframe-container"
              frameBorder="0"
              allowFullScreen
              mozallowfullscreen="true"
              webkitallowfullscreen="true"
              allow="autoplay; xr-spatial-tracking;"
              xr-spatial-tracking="true"
              execution-while-out-of-viewport="true"
              execution-while-not-rendered="true"
              web-share="true"
            ></iframe>
            {arplayer && <ARPlayer url={arplayer} setArplayer={setArplayer} />}
            {videoPlayer && (
              <VideoPlayerSketchfab
                videolink={videoPlayer}
                setVideoPlayer={setVideoPlayer}
              />
            )}
            {pdfPlayer && (
              <PDFsketchfab pdfPlayer={pdfPlayer} setPDFplayer={setPDFplayer} />
            )}
            <Col
              className="viewer-nav d-flex top-left justify-content-start"
              id="topleft"
            >
              {animationCollection.cutView && (
                <TogglePlayerButton
                  setActive={setActive}
                  clearActiveState={clearActiveState}
                  setAnimation={setAnimation}
                  animationCollection={animationCollection}
                  data={toggleCutIdleState}
                  setData={setToggleCutIdleState}
                  iconname="cutout-icon.svg"
                  iconSelect="cutView"
                  setIconClicked={setIconClicked}
                  hideAnnotations={hideAnnotations}
                />
              )}

              {animationCollection.combine && (
                <TogglePlayerButton
                  setActive={setActive}
                  clearActiveState={clearActiveState}
                  setAnimation={setAnimation}
                  animationCollection={animationCollection}
                  data={toggleExplodedCombineState}
                  setData={setToggleExplodedCombineState}
                  iconname="exploted-icon.svg"
                  iconSelect="exploded"
                  setIconClicked={setIconClicked}
                  hideAnnotations={hideAnnotations}
                />
              )}

              {animationCollection.playAni && (
                <Tooltip title={animationTitle} arrow>
                  <div
                    className="on-cursor mx-1"
                    data-name="controls"
                    onClick={togglePlayAnimation}
                  >
                    <img
                      className="img-icon overlay-animation "
                      id="animation"
                      src="assets\white-icon\animation-icon.svg"
                      alt="img"
                    ></img>
                  </div>
                </Tooltip>
              )}

              {assetData?.hasAnnotation && (
                <Tooltip title={annotationTitle} arrow>
                  <div
                    className="on-cursor mx-1"
                    onClick={toggleAnnotation}
                    data-name="controls"
                    id="annotation-switch"
                  >
                    <img
                      className="img-icon overlay-annotation "
                      src="assets\white-icon\annotation-icon.svg"
                      alt="img"
                    ></img>
                  </div>
                </Tooltip>
              )}

              {assetData?.audio && (
                <Tooltip title={audioTitle} arrow>
                  <div
                    className="on-cursor mx-1"
                    onClick={(e) => handleAudio(assetData.audio)}
                    data-name="controls"
                    id="audio-controls"
                  >
                    <img
                      className="img-icon"
                      src="assets\white-icon\audio-icon.svg"
                      alt="Audio"
                    ></img>
                  </div>
                </Tooltip>
              )}
              <Tooltip title="Reset" arrow>
                <div className="on-cursor mx-1" onClick={resetAllPlayer}>
                  <img
                    className="img-icon"
                    src="assets\white-icon\reset-icon.svg"
                    alt="gear"
                    style={{ color: "white" }}
                  />
                </div>
              </Tooltip>
            </Col>
            <Col className="viewer-nav d-flex top-center justify-content-center">
              {assetData.audio && (
                <div id="voiceover">
                  <audio
                    controls
                    id="audio1"
                    loop={false}
                    preload="true"
                    className="audio-player-controls p-1 w-full bg-transparent border-0"
                  >
                    <source
                      src={`audio\\${assetData.audio}`}
                      id="srcMP3"
                      type="audio/mp3"
                    />
                    <div>Your Browser will not support this audio</div>
                  </audio>
                </div>
              )}
            </Col>
            <Col className="viewer-nav d-flex top-right justify-content-end">
              {assetData?.video && (
                <Tooltip title="Video" arrow>
                  <div className="on-cursor mx-1" onClick={toggleVideoPlayer}>
                    <img
                      className="img-icon"
                      src="assets\white-icon\video-icon.svg"
                      alt="gear"
                      style={{ color: "white" }}
                    />
                  </div>
                </Tooltip>
              )}
              {assetData?.pdf && (
                <Tooltip title="View PDFs" arrow>
                  <div className="on-cursor mx-1" onClick={togglePDFPlayer}>
                    <img
                      className="img-icon overlay-pdf "
                      src="assets\white-icon\pdf-icon.svg"
                      alt="img"
                    ></img>
                  </div>
                </Tooltip>
              )}
              {isMobile || isTablet ? (
                <Tooltip title="Open AR" arrow>
                  <a
                    href={`https://testing.paracosma.com/ar-object-viewer/${arPlayerId}`}
                    target="_blank"
                  >
                    <div className="on-cursor mx-1 accordion">
                      <img
                        className="img-icon"
                        src="assets\white-icon\ar-icon.svg"
                        alt="Open AR"
                      />
                    </div>
                  </a>
                </Tooltip>
              ) : (
                <Tooltip title="View in AR" arrow>
                  <div
                    className="on-cursor mx-1 accordion"
                    onClick={toggleARModal}
                  >
                    <img
                      className="img-icon"
                      src="assets\white-icon\ar-icon.svg"
                      alt="ar"
                    />
                  </div>
                </Tooltip>
              )}
            </Col>
            <Col className="viewer-nav d-grid zoom-container- middle-right">
              <Tooltip placement="left" title="Zoom In" arrow>
                <div
                  className="zoom d-flex justify-content-center mb-2"
                  onClick={() => zoomIn()}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              </Tooltip>

              <Tooltip placement="left" title="Reset" arrow>
                <div
                  className="zoom d-flex justify-content-center align-content-center"
                  onClick={() => {
                    setAnimation("-1", 0);
                    clearActiveState();
                  }}
                >
                  <img
                    className="img-icon-side"
                    src="assets\white-icon\reset-icon.svg"
                    alt="gear"
                    style={{ color: "white" }}
                  />
                </div>
              </Tooltip>

              <Tooltip placement="left" title="Zoom Out" arrow>
                <div
                  className="zoom d-flex justify-content-center mt-2"
                  onClick={() => zoomOut()}
                >
                  <FontAwesomeIcon icon={faMinus} />
                </div>
              </Tooltip>
            </Col>
            <Col className="viewer-nav d-flex flex-column bottom-center justify-content-center main-btn-container">
              <div className="d-flex justify-content-center ">
                <div className="play-pause-container overlay-play">
                  <Tooltip title="Play" arrow>
                    <i
                      id="toggle-play"
                      className="far fa-play-circle fs-5 fa-2x p-1 p-md-2 play-button on-cursor"
                      onClick={() => {
                        togglePlayPause("play");
                      }}
                      style={{ color: "white" }}
                    ></i>
                  </Tooltip>
                  <Tooltip title="Pause" arrow>
                    <i
                      id="toggle-pause"
                      className="far fa-pause-circle fs-5 fa-2x p-1 p-md-2  pause-button on-cursor"
                      onClick={() => togglePlayPause("pause")}
                      style={{ color: "white" }}
                    ></i>
                  </Tooltip>
                </div>
                <div className="overlay-slider mx-3 align-self-center">
                  <input
                    id="timeSlider"
                    style={{ width: "100%" }}
                    type="range"
                    min="0"
                    max="100"
                    step="0.1"
                    value={sliderValue}
                    onChange={(e) => {
                      container.classList.remove("active");
                      setSliderValue(e.target.value);
                    }}
                  />
                </div>
              </div>
              {assetData?.hasAnnotation && !enableAnnotation && (
                <div className="d-flex overlay-button justify-content-center my-1">
                  <button
                    id="annotate-prev-"
                    className="annotate-button mx-2 mx-md-5"
                    onClick={handlePrevAnnotation}
                  >
                    Prev
                  </button>
                  <button
                    id="annotate-next-"
                    className="annotate-button mx-2 mx-md-5"
                    onClick={handleNextAnnotation}
                  >
                    Next
                  </button>
                </div>
              )}
            </Col>
            <Col className="viewer-nav d-flex bottom-right justify-content-end">
              <span
                onClick={handleFullScreen}
                className="bg-transparent border-0 cursor-pointer"
              >
                <FontAwesomeIcon
                  title={iconTitle.fullscreen}
                  className="text-primary p-1 m-md-2 p-md-2"
                  icon={faIcon}
                />
              </span>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default SketchfabPlayerOnly;
